import { render } from "./main-content.vue?vue&type=template&id=0521ae19&ts=true"
import script from "./main-content.ts?vue&type=script&lang=ts&external"
export * from "./main-content.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__